/** RTK Query / FetchBaseQuery error body from DRF. */
export function errorDetailFromUnknown(e: unknown): string | undefined {
  if (e && typeof e === "object" && "data" in e) {
    const data = (e as { data?: { detail?: unknown } }).data;
    if (data && typeof data.detail === "string") {
      return data.detail;
    }
  }
  return undefined;
}
